import React from 'react'
import { Form, Input } from 'antd'
import { Controller } from 'react-hook-form'

export interface InputFieldProps {
  fieldname: string
  isRequired?: boolean
  label?: string
  validate?: any
  validMessage?: any
  className?: string
  control: any
  initValue?: any
  rules?: any
  iProps?: any
  prefix?: any
}

const InputField: React.FunctionComponent<InputFieldProps> = ({
  fieldname,
  isRequired,
  label,
  validate,
  validMessage,
  className,
  control,
  initValue,
  rules,
  iProps,
  prefix,
}: InputFieldProps) => {
  return (
    <Form.Item
      required={isRequired ?? false}
      label={label}
      validateStatus={validate}
      help={validMessage}
      className={className}
    >
      <Controller
        name={fieldname}
        control={control}
        defaultValue={initValue ?? ''}
        rules={rules}
        render={({ field: { onChange, value, onBlur } }) => (
          <Input.Password
            value={value}
            className="formControl"
            prefix={prefix}
            onChange={(e) => {
              onChange(e)
            }}
            {...iProps}
          />
        )}
      />
    </Form.Item>
  )
}

export default InputField
